import React, { useState, forwardRef } from "react";

const InputText = forwardRef(({
  title,
  placeholder = "",
  type = "text",
  onChange,
  password = false,
  error,
  ...rest
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mt-4 ">
      {title && (
        <label className="text-base text-primary-text font-semibold">
          {title}
        </label>
      )}

      <div className="relative mt-2">
        <input
          ref={ref}
          type={password ? (showPassword ? "text" : "password") : type}
          placeholder={placeholder}
          onChange={onChange}
          className="w-full border-none bg-[#f1f1f1] font-medium focus:outline-none rounded-[10px] p-3"
          {...rest}
        />

        {password && (
          <button
            type="button"
            className="absolute top-[15px] right-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <i className="fi fi-rr-eye text-[#676E87]"></i>
            ) : (
              <i className="fi fi-rr-eye-crossed text-[#676E87]"></i>
            )}
          </button>
        )}
      </div>
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
});

export default InputText;
